import { BaseService, Service, Permission } from "/@/cool";

@Service("agree")
class Common extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["info"] = prefix + "info";
		this.permission["sign"] = prefix + "sign";
		this.permission["confirm"] = prefix + "confirm";
		this.permission["close"] = prefix + "close";
		this.permission["cancel"] = prefix + "cancel";
		this.permission["reject"] = prefix + "reject";
	}

	/**
	 * 文件上传模式
	 */
	@Permission("info")
	info(data: any) {
		return this.request({
			url: "/info",
			method: "post",
			data: data
		});
	}

	@Permission("close")
	close(data: any) {
		return this.request({
			url: "/close",
			method: "post",
			data: data
		});
	}

	@Permission("sign")
	sign(data: any) {
		return this.request({
			url: "/sign",
			method: "post",
			data: data
		});
	}

	@Permission("confirm")
	confirm(data: any) {
		return this.request({
			url: "/confirm",
			method: "post",
			data: data
		});
	}

	@Permission("cancel")
	cancel(data: any) {
		return this.request({
			url: "/cancel",
			method: "post",
			data: data
		});
	}

	@Permission("reject")
	reject(data: any) {
		return this.request({
			url: "/reject",
			method: "post",
			data: data
		});
	}
}

export default Common;
